import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  page: 0,
  personalInformation: {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    fax: "",
    jobTitle: "",
    company: "",
    buildingNumber: "",
    principalInvestigator: "",
  },
  password: {
    current: "",
    new: "",
    confirmNew: "",
  },
  purchasingAgent: {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    company: "",
    fax: "",
  },
  paymentDetails: {
    name: "",
    number: "",
    month: "",
    year: "",
    cvv: "",
  },
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    //action creators
    setPage(state, action) {
      state.page = action.payload;
    },
    setProfileUserData(state,action) {
      state.personalInformation = action.payload
    },
    setProfilePurchasingAgent(state,action) {
      state.purchasingAgent = action.payload
    },
    resetProfile: () => initialState,
    editPersonalInformation(state,action){
      const  { value, property } = action.payload
      let currentInformation = state.personalInformation
      currentInformation[property] = value
    },
    editPurchasingAgentInformation(state,action){
      const  { value, property } = action.payload
      let currentInformation = state.purchasingAgent
      currentInformation[property] = value
    }
  },
  //tell our combined reducer to look for additional action types
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return {};
    });
  },
});

export const { setPage, setProfileUserData, setProfilePurchasingAgent, resetProfile, editPersonalInformation, editPurchasingAgentInformation } = profileSlice.actions;
export const profileReducer = profileSlice.reducer;
